export default __webpack_public_path__ + "static/ReviewsBackground-d9d5ae8dc348037f97df2a33fa856052.png";